import { AssetsInfo, CompanyPositionData, PeriodEnum } from '@interfaces'
import { api } from '@utils/api/api'

export const getCompanyInvestments = (
  id: string,
  realTimePrices = true,
): Promise<CompanyPositionData> => {
  return api.get(
    `/api/v1/portfolio/performance/holding/${id}${
      realTimePrices ? '?realTimePrices=true' : ''
    }`,
  )
}

export const getAssetDetail = (
  assetId: string,
  period = PeriodEnum.day,
): Promise<AssetsInfo> => {
  return api.get(`/api/v3/mobile/assets/${assetId}?period=${period}`)
}
